import VulSourceItem, {AggregatedAiAttributeValue} from "../../domain/VulSourceItem";

export function getSummaryAiAttributeEntries(item: VulSourceItem | undefined): [string, AggregatedAiAttributeValue][] {
    return Object.entries(item?.aiAttributes ?? {}).filter(([, value]) => value?.resultType === "VALUE_SUMMARY");
}

export function getRatingAiAttributeEntries(item: VulSourceItem | undefined): [string, AggregatedAiAttributeValue][] {
    return Object.entries(item?.aiAttributes ?? {}).filter(([, value]) => value?.resultType === "VALUE_RATING");
}

export function getTextAiAttributeEntries(item: VulSourceItem | undefined): [string, AggregatedAiAttributeValue][] {
    return Object.entries(item?.aiAttributes ?? {}).filter(([, value]) =>
        value?.resultType !== "VALUE_SUMMARY" && value?.resultType !== "VALUE_RATING"
    );
}
